module.exports = __webpack_public_path__ + "static/media/icims-logo-r.5e63bb45.svg";